import React, { createContext, useContext } from "react";
import { useFreshFavorites } from "../hooks/useFreshFavorites";
import { FavoritesContext } from "./context";

export const FavoritesProvider = ({ children }) => {
  // Usar el nuevo hook que sincroniza automáticamente con el backend
  const favoritesHook = useFreshFavorites();

  // Función adicional para compatibilidad con el código existente
  const addToFavorites = (product) => {
    return favoritesHook.toggleFavorite(product);
  };

  const removeFromFavorites = (productId) => {
    // Para remover, necesitamos crear un producto mock con el ID
    return favoritesHook.toggleFavorite({ id: productId });
  };

  const clearAllFavorites = () => {
    return favoritesHook.clearCache();
  };

  // Obtener favoritos en formato de array (para compatibilidad)
  const getUserFavorites = () => {
    return favoritesHook.getUserFavorites();
  };

  const value = {
    // Estados del hook
    ...favoritesHook,

    // Funciones adicionales para compatibilidad
    addToFavorites,
    removeFromFavorites,
    clearAllFavorites,
    getUserFavorites,

    // Alias para compatibilidad con código existente
    favorites: Array.from(favoritesHook.favorites.values()),
    favoritesMap: favoritesHook.favorites,
  };

  return (
    <FavoritesContext.Provider value={value}>
      {children}
    </FavoritesContext.Provider>
  );
};
